module.exports = __webpack_public_path__ + "img/mist.12976bbb.svg";